import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';

import { ConfigureService } from './configure.service';

// @dynamic
@NgModule({
    imports: [
        HttpClientModule
    ],
    declarations: [],
    providers: [
        ConfigureService,
        {
            provide: APP_INITIALIZER,
            useFactory: init,
            multi: true,
            deps: [ConfigureService]
        }
    ]
})
export class ConfigureModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: ConfigureModule,
            providers: [ConfigureService]
        };
    }
}

export function init(configService: ConfigureService): Function {
    return () => configService.load();
}
